var map;
var InfoObj = [];

var icons = {
  par2:{
    icon: 'https://cdn.shopify.com/s/files/1/0495/7532/9941/files/PAR2-pointer.png?v=1677793895'
  }
};

var markersOnMap = [
  {
    storecode: 'P01',
    placeName: 'PAR2 Centro San Salvador',
    storeAddress: 'C. Rubén Darío y 7a Av. Sur Edif. Emicar, local 2 y 3',
    schedule: 'Lunes a Domingo: 8:00am a 6:00pm',
    phone: '22220811',
    whatsapp: '72752074',
    page: 'https://g.page/r/CW9IYZHQoB-HEBM',
    review: 'https://g.page/r/CW9IYZHQoB-HEBM/review',
    zona: 1,
    LatLng: [{
      lat: 13.698518,
      lng: -89.1951305
    }],
    type: 'par2'
  },
  {
    storecode: 'P02',
    placeName: 'PAR2 Soyapango',
    storeAddress: '4a. Av. Sur Contiguo a Hiper Paíz',
    schedule: 'Lunes a Sábado: 8:00am a 6:00pm<br>Domingo: 8:00am a 5:00pm',
    phone: '22274118',
    whatsapp: '72752074',
    page: 'https://g.page/r/CY98b59h5J4FEBM',
    review: 'https://g.page/r/CY98b59h5J4FEBM/review',
    zona: 1,
    LatLng: [{
      lat: 13.7006884,
      lng: -89.1496581
    }],
    type: 'par2'
  },
  {
    storecode: 'P03',
    placeName: 'PAR2 San Vicente',
    storeAddress: 'C. Quiñonez Osorio No. 12-A, San Vicente',
    schedule: 'Lunes a Sábado: 8:00am a 6:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '23935719',
    whatsapp: '72752074',
    page: 'https://g.page/r/CaOePG5jfhNcEBM',
    review: 'https://g.page/r/CaOePG5jfhNcEBM/review',
    zona: 2,
    LatLng: [{
      lat: 13.6444056,
      lng: -88.786109
    }],
    type: 'par2'
  },
  {
    storecode: 'P04',
    placeName: 'PAR2 Metrocentro San Miguel',
    storeAddress: 'CC Metrocentro San Miguel, Local 15 y 16',
    schedule: 'Lunes a Domingo: 9:00am a 8:00pm',
    phone: '26673031',
    whatsapp: '72752074',
    page: 'https://g.page/r/CdeGW321YgmSEBM',
    review: 'https://g.page/r/CdeGW321YgmSEBM/review',
    zona: 4,
    LatLng: [{
      lat: 13.4618951,
      lng: -88.1659915
    }],
    type: 'par2'
  },
  {
    storecode: 'P05',
    placeName: 'PAR2 La Unión',
    storeAddress: 'Calle General Menendez No. 1-1, La Unión',
    schedule: 'Lunes a Sábado: 8:00am a 5:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '26041318',
    whatsapp: '72752074',
    page: 'https://g.page/r/CdeGW321YgmSEBM',
    review: 'https://g.page/r/CdeGW321YgmSEBM/review',
    zona: 4,
    LatLng: [{
      lat: 13.3366304,
      lng: -87.8425242
    }],
    type: 'par2'
  },
  {
    storecode: 'P07',
    placeName: 'PAR2 San Jacinto',
    storeAddress: '1a. Av. Sur y C. Lara, CC Plaza México, Local 2 y 3, San Jacinto',
    schedule: 'Lunes a Domingo: 9:00am a 7:00pm',
    phone: '22702872',
    whatsapp: '72752074',
    page: 'https://g.page/r/CSnXvON4mKYAEBM/',
    review: 'https://g.page/r/CSnXvON4mKYAEBM/review',
    zona: 1,
    LatLng: [{
      lat: 13.6848042,
      lng: -89.1917997
    }],
    type: 'par2'
  },
  {
    storecode: 'P08',
    placeName: 'PAR2 El Encuentro San Marcos',
    storeAddress: 'CC El Encuentro, Local L-29 y L-30',
    schedule: 'Lunes a Sábado: 9:00am a 8:00pm<br>Domingo: 9:00am a 7:00pm',
    phone: '22690213',
    whatsapp: '72752074',
    page: 'https://g.page/r/CdQeBCZ05hZAEBM/',
    review: 'https://g.page/r/CdQeBCZ05hZAEBM/review',
    zona: 1,
    LatLng: [{
      lat: 13.6623359,
      lng: -89.1838649
    }],
    type: 'par2'
  },  
  {
    storecode: 'P12',
    placeName: 'PAR2 La Unión II',
    storeAddress: 'Av. Gral. Cabañas y C. San Carlos No. 2, La Unión',
    schedule: 'Lunes a Sábado: 8:00am a 5:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '26041314',
    whatsapp: '72752074',
    page: 'https://g.page/r/CSSAx5mMJdlSEBM/',
    review: 'https://g.page/r/CSSAx5mMJdlSEBM/review',
    zona: 4,
    LatLng: [{
      lat: 13.336978104303448,
      lng: -87.84354252654948
    }],
    type: 'par2'
  },
  {
    storecode: 'P13',
    placeName: 'PAR2 Juayua',
    storeAddress: '5a. Av. Sur. y C. Pte., Local 2, Bo. San José, Juayua',
    schedule: 'Lunes a Sábado: 8:00am a 6:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '24692532',
    whatsapp: '72752074',
    page: 'https://goo.gl/maps/BdgzA5KEw4t74oLp7',
    review: '',
    zona: 3,
    LatLng: [{
      lat: 13.8426916,
      lng: -89.7475772
    }],
    type: 'par2'
  },
  {
    storecode: 'P14',
    placeName: 'PAR2 Zacatecoluca',
    storeAddress: '2a. C. Pte. y Av. Juan Manuel Rodríguez, Zacatecoluca',
    schedule: 'Lunes a Sábado: 8:00am a 5:00pm<br>Domingo: 8:00am a 1:00pm',
    phone: '23341262',
    whatsapp: '72752074',
    page: 'https://goo.gl/maps/tpJbScJDaKNXT7RS9',
    review: '',
    zona: 4,
    LatLng: [{
      lat: 13.515857,
      lng: -88.8694871999999
    }],
    type: 'par2'
  },
   {
    storecode: 'P15',
    placeName: 'PAR2 San Francisco Gotera',
    storeAddress: '3a. C. Pte. y Av. Morazán No. 5, San Francisco Gotera',
    schedule: 'Lunes a Sábado: 8:00am a 5:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '26541180',
    whatsapp: '72752074',
    page: 'https://g.page/r/CUCdnw0Li8SdEBM',
    review: 'https://g.page/r/CUCdnw0Li8SdEBM/review',
    zona: 4,
    LatLng: [{
      lat: 13.6981769,
      lng: -88.1042446
    }],
    type: 'par2'
  },
  {
    storecode: 'P17',
    placeName: 'PAR2 Aguilares',
    storeAddress: '6a. C. Ote. Pje. 01, Aguilares',
    schedule: 'Lunes a Sábado: 8:00am a 5:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '23214623',
    whatsapp: '72752074',
    page: 'https://goo.gl/maps/darfuxYsLFy3fEm87',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 13.9573038,
      lng: -89.1853641
    }],
    type: 'par2'
  },
  {
    storecode: 'P19',
    placeName: 'PAR2 Santa Ana Centro I',
    storeAddress: '1. C. Ote. y Av. Independencia Sur No. 2, Barrio el Centro, Santa Ana',
    schedule: 'Lunes a Sábado: 8:00am a 6:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '24477928',
    whatsapp: '72752074',
    page: '',
    review: '',
    zona: 3,
    LatLng: [{
      lat: 13.9938001,
      lng: -89.5571618
    }],
    type: 'par2'
  },
  {
    storecode: 'P20',
    placeName: 'PAR2 Plaza Mundo Soyapango',
    storeAddress: 'CC Plaza Mundo, 2a. Planta, Local 112, 113 y 114, Soyapango',
    schedule: 'Lunes a Domingo: 9:00am a 8:00pm',
    phone: '22770057',
    whatsapp: '72752074',
    page: 'https://g.page/r/CTzOi_yOSmM_EBM/',
    review: 'https://g.page/r/CTzOi_yOSmM_EBM/review',
    zona: 1,
    LatLng: [{
      lat: 13.6984361,
      lng: -89.1508562
    }],
    type: 'par2'
  },
  {
    storecode: 'P22',
    placeName: 'PAR2 Centro San Salvador',
    storeAddress: 'Av. España, Plaza España, Local 16, San Salvador',
    schedule: 'Lunes a Domingo: 8:00am a 6:00pm',
    phone: '22225284',
    whatsapp: '72752074',
    page: 'https://goo.gl/maps/hZagWNqv7edkhnwg7',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 13.6995549,
      lng: -89.1912714
    }],
    type: 'par2'
  },
  {
    storecode: 'P23',
    placeName: 'PAR2 Autopista Sur',
    storeAddress: 'CC Autopista Sur C. Los Víveros y C. Antigua a Huizucar, Local 18, San Salvador',
    schedule: 'Lunes a Sábado: 9:00am a 7:00pm<br>Domingo: 9:00am a 6:00pm',
    phone: '22736044',
    whatsapp: '72752074',
    page: 'https://goo.gl/maps/mV3pfCPNckVgbDxh7',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 13.68364845938499,
      lng: -89.2219695778068
    }],
    type: 'par2'
  },
  {
    storecode: 'P24',
    placeName: 'PAR2 Cojutepeque',
    storeAddress: 'CC Cuscatlán, 2 Av. Sur, local 1-2b y 7a',
    schedule: 'Lunes a Sábado: 8:00am a 5:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '23721071',
    whatsapp: '72752074',
    page: 'https://goo.gl/maps/wxmcHii1iW1LNndL8',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 13.720979985219943,
      lng: -88.93654851725884
    }],
    type: 'par2'
  },
  {
    storecode: 'P25',
    placeName: 'PAR2 Unicentro Soyapango',
    storeAddress: 'CC Unicentro, Local 35 y 36, Soyapango',
    schedule: 'Lunes a Domingo: 9:00am a 8:00pm',
    phone: '22910331',
    whatsapp: '72752074',
    page: 'https://g.page/r/CYTT0TVH4YrwEBM/',
    review: 'https://g.page/r/CYTT0TVH4YrwEBM/review',
    zona: 1,
    LatLng: [{
      lat: 13.715193,
      lng: -89.1408574
    }],
    type: 'par2'
  },
  {
    storecode: 'P26',
    placeName: 'PAR2 Metrocentro Santa Ana',
    storeAddress: 'CC Metrocentro Santa Ana, Local 165-C',
    schedule: 'Lunes a Domingo: 9:00am a 7:00pm',
    phone: '24409125',
    whatsapp: '72752074',
    page: 'https://g.page/r/CQXLNWTKjin5EBM/',
    review: 'https://g.page/r/CQXLNWTKjin5EBM/review',
    zona: 3,
    LatLng: [{
      lat: 13.9777312,
      lng: -89.5621851
    }],
    type: 'par2'
  },
  {
    storecode: 'P28',
    placeName: 'PAR2 Ilobasco',
    storeAddress: 'Av. Carlos Bonilla Local No. 2, Ilobasco',
    schedule: 'Lunes a Sábado: 8:00am a 5:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '23322303',
    whatsapp: '72752074',
    page: 'https://g.page/r/CVDv_PGQx2MYEBM/',
    review: 'https://g.page/r/CVDv_PGQx2MYEBM/review',
    zona: 2,
    LatLng: [{
      lat: 13.8415136,
      lng: -88.8511656
    }],
    type: 'par2'
  },
  {
    storecode: 'P29',
    placeName: 'PAR2 Sonsonate Centro I',
    storeAddress: 'C. Obispo Marroquín No. 5-8, Sonsonate',
    schedule: 'Lunes a Sábado: 8:00am a 6:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '24517718',
    whatsapp: '72752074',
    page: 'https://g.page/r/Ca198sKinEtEEBM/',
    review: 'https://g.page/r/Ca198sKinEtEEBM/review',
    zona: 3,
    LatLng: [{
      lat: 13.7178881,
      lng: -89.7240862999999
    }],
    type: 'par2'
  },
  {
    storecode: 'P30',
    placeName: 'PAR2 Quezaltepeque',
    storeAddress: 'Av. 3 de Mayo, CC Metromila Local 3, Quezaltepeque',
    schedule: 'Lunes a Sábado: 8:00am a 5:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '23998712',
    whatsapp: '72752074',
    page: 'https://goo.gl/maps/vzR4U5VgGncBwpxr5',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 13.8343759,
      lng: -89.2723456
    }],
    type: 'par2'
  },
  {
    storecode: 'P31',
    placeName: 'PAR2 Metrópolis',
    storeAddress: 'CC Plaza Metrópolis No. 25 y 26, Zacamil, San Salvador',
    schedule: 'Lunes a Domingo: 9:00am a 7:00pm',
    phone: '22725392',
    whatsapp: '72752074',
    page: 'https://goo.gl/maps/qRpPVToKh92KFeLaA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 13.7295323,
      lng: -89.2098576
    }],
    type: 'par2'
  },
  {
    storecode: 'P32',
    placeName: 'PAR2 El Encuentro Sonsonate',
    storeAddress: 'CC El Encuentro Sonsonate, Mini Ancla 5, Sonsonate',
    schedule: 'Lunes a Domingo: 9:00am a 7:00pm',
    phone: '24762123',
    whatsapp: '72752074',
    page: '',
    review: '',
    zona: 3,
    LatLng: [{
      lat: 13.7106082,
      lng: -89.7204171
    }],
    type: 'par2'
  },
  {
    storecode: 'P33',
    placeName: 'PAR2 Chalatenango',
    storeAddress: '3a Av.Nte y 4a. C. Pte. No. 7, Chalatenango',
    schedule: 'Lunes a Domingo: 8:00am a 5:00pm',
    phone: '23352350',
    whatsapp: '72752074',
    page: 'https://g.page/r/CS9M3iV_e0RyEBM/',
    review: 'https://g.page/r/CS9M3iV_e0RyEBM/review',
    zona: 1,
    LatLng: [{
      lat: 14.040741635401503,
      lng: -88.93947983158843
    }],
    type: 'par2'
  },
  {
    storecode: 'P35',
    placeName: 'PAR2 Ruben Darío',
    storeAddress: 'C. Rubén Darío No. 611, San Salvador',
    schedule: 'Lunes a Domingo: 8:00am a 6:00pm',
    phone: '22211862',
    whatsapp: '72752074',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 13.6985878,
      lng: -89.1962976
    }],
    type: 'par2'
  },
   {
    storecode: 'P36',
    placeName: 'PAR2 Galerías Escalon',
    storeAddress: 'Centro comercial Galerias primer nivel local 120',
    schedule: 'Lunes a Domingo: 8:00am a 6:00pm',
    phone: '75958981',
    whatsapp: '75958981',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 13.7024661739,
      lng: -89.2298886887
    }],
    type: 'par2'
  },
  {
    storecode: 'P37',
    placeName: 'PAR2 Paseo Venecia',
    storeAddress: 'CC Plaza Venecia, Edif. E, Local 58, 1er. Nivel, Km 21 Carr. de Oro, Soyapango',
    schedule: 'Lunes a Domingo: 09:00am a 8:00pm',
    phone: '25648300',
    whatsapp: '72752074',
    page: 'https://goo.gl/maps/qw9nLfUwqJyLKzrE9',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 13.715616215560496,
      lng: -89.14405666907031
    }],
    type: 'par2'
  },
  {
    storecode: 'P38',
    placeName: 'PAR2 San Miguel Centro',
    storeAddress: '3a. Av. Nte. y 2a. C. Pte. San Miguel',
    schedule: 'Lunes a Sábado: 8:00am a 5:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '26066065',
    whatsapp: '72752074',
    page: 'https://g.page/r/CZ3FBsAci8xKEBM/',
    review: 'https://g.page/r/CZ3FBsAci8xKEBM/review',
    zona: 4,
    LatLng: [{
      lat: 13.4818999,
      lng: -88.1790731
    }],
    type: 'par2'
  },
  {
    storecode: 'P39',
    placeName: 'PAR2 Centro Usulutan',
    storeAddress: 'C. Grimaldi No. 30, Usulutan',
    schedule: 'Lunes a Sábado: 8:00am a 5:00pm<br>Domingo: 8:00am a 1:00pm',
    phone: '26247972',
    whatsapp: '72752074',
    page: '',
    review: '',
    zona: 4,
    LatLng: [{
      lat: 13.3438418,
      lng: -88.4363604
    }],
    type: 'par2'
  },
  {
    storecode: 'P40',
    placeName: 'PAR2 Plaza Mundo',
    storeAddress: 'CC Plaza Mundo, Local 13, 14 y 15, Nivel 1, Soyapango',
    schedule: 'Lunes a Domingo: 9:00am a 8:00pm',
    phone: '22773039',
    whatsapp: '72752074',
    page: 'https://goo.gl/maps/eXcB8yDm5otoVp8Z8',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 13.6989471,
      lng: -89.1496918
    }],
    type: 'par2'
  },
  {
    storecode: 'P41',
    placeName: 'PAR2 El Encuentro San Miguel',
    storeAddress: 'CC El Encuentro El Sitio, Local 2, 3 y 4, Ctra. Panamericana',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '22226434',
    whatsapp: '72752074',
    page: 'https://goo.gl/maps/Wpv9bq96xMF8y2Fa8',
    review: '',
    zona: 4,
    LatLng: [{
      lat: 13.496051,
      lng: -88.1982941
    }],
    type: 'par2'
  },
  {
    storecode: 'P48',
    placeName: 'PAR2 Sonsonate Centro II',
    storeAddress: 'Calle Obispo Marroquin 2-10, Sonsonate',
    schedule: 'Lunes a Sábado: 8:00am a 6:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '24518121',
    whatsapp: '72752074',
    page: '',
    review: '',
    zona: 3,
    LatLng: [{
      lat: 13.7193327,
      lng:-89.7264322
    }],
    type: 'par2'
  },
  {
    storecode: 'P49',
    placeName: 'PAR2 Pericentro Apopa',
    storeAddress: 'CC Pericentro Apopa, Local 1, 2 y 3, Apopa',
    schedule: 'Lunes a Domingo: 8:00am a 6:00pm',
    phone: '22144099',
    whatsapp: '72752074',
    page: 'https://goo.gl/maps/QcTyPHwh66pviLWi7',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 13.7938725,
      lng: -89.1775862
    }],
    type: 'par2'
  },
  {
    storecode: 'P50',
    placeName: 'PAR2 Puerto de La Libertad',
    storeAddress: 'C. Gerardo Barrios 11-17, La Libertad',
    schedule: 'Lunes a Sábado: 8:00am a 5:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '23353232',
    whatsapp: '72752074',
    page: 'https://goo.gl/maps/vQk6kWbTiT3axXTo6',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 13.4883503,
      lng: -89.3189604
    }],
    type: 'par2'
  },
  {
    storecode: 'P51',
    placeName: 'PAR2 Plaza Mundo',
    storeAddress: 'CC Plaza Mundo Local 81, 81a, 82b y 82c, Nivel 2, Soyapango',
    schedule: 'Lunes a Domingo: 9:00am a 8:00pm',
    phone: '22773557',
    whatsapp: '72752074',
    page: 'https://g.page/r/CY1mJxuAj9dcEBM/',
    review: 'https://g.page/r/CY1mJxuAj9dcEBM/review',
    zona: 1,
    LatLng: [{
      lat: 13.6992311,
      lng: -89.1503496
    }],
    type: 'par2'
  },
  {
    storecode: 'P53',
    placeName: 'PAR2 Ahuachapán',
    storeAddress: '10a. C. Pte. y Av. 2 de Abril, Ahuachapán',
    schedule: 'Lunes a Sábado: 8:00am a 6:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '24431218',
    whatsapp: '72752074',
    page: 'https://g.page/r/CeVruQ3YArXBEBM/',
    review: 'https://g.page/r/CeVruQ3YArXBEBM/review',
    zona: 3,
    LatLng: [{
      lat: 13.9254187,
      lng: -89.8460894
    }],
    type: 'par2'
  },
  {
    storecode: 'P54',
    placeName: 'PAR2 Centro Santa Tecla',
    storeAddress: '2a. C. Ote. 2-1 Portal Fte. a Mercado Santa Tecla',
    schedule: 'Lunes a Sábado: 8:00am a 6:00pm<br>Domingo: 8:00am a 5:00pm',
    phone: '22281766',
    whatsapp: '72752074',
    page: 'https://g.page/r/CYqdyPWk9lh2EBM/',
    review: 'https://g.page/r/CYqdyPWk9lh2EBM/review',
    zona: 1,
    LatLng: [{
      lat: 13.673118587064254,
      lng: -89.28768880892852
    }],
    type: 'par2'
  },
  {
    storecode: 'P55',
    placeName: 'PAR2 Unicentro Altavista',
    storeAddress: 'CC Altavista, Local C11, C12 y C13, Ilopango',
    schedule: 'Lunes a Domingo: 9:00am a 8:00pm',
    phone: '22997019',
    whatsapp: '72752074',
    page: 'https://g.page/r/Cdh44Br9v8fUEBM/',
    review: 'https://g.page/r/Cdh44Br9v8fUEBM/review',
    zona: 1,
    LatLng: [{
      lat: 13.7167939,
      lng: -89.0972768
    }],
    type: 'par2'
  },
  {
    storecode: 'P56',
    placeName: 'PAR2 Metrocentro Lourdes',
    storeAddress: 'CC Metrocentro Lourdes, Local H17, H18 y H19, Colón',
    schedule: 'Lunes a Domingo: 9:00am a 7:00pm',
    phone: '25668432',
    whatsapp: '72752074',
    page: 'https://goo.gl/maps/umwmVR6T3D5MtpVV7',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 13.7280113,
      lng: -89.3594023
    }],
    type: 'par2'
  },
  {
    storecode: 'P57',
    placeName: 'PAR2 Metrocentro San Salvador',
    storeAddress: 'CC Metrocentro, Local 1-2 A, 4a Etapa, San Salvador',
    schedule: 'Domingo a Jueves: 9:00am a 7:00pm<br>Viernes y Sábado 9:00am a 8:00pm',
    phone: '22607930',
    whatsapp: '72752074',
    page: 'https://g.page/r/CZJctnDeAQT6EBM/',
    review: 'https://g.page/r/CZJctnDeAQT6EBM/review',
    zona: 1,
    LatLng: [{
      lat: 13.706105,
      lng: -89.2119793
    }],
    type: 'par2'
  },
  {
    storecode: 'P58',
    placeName: 'PAR2 Las Cascadas',
    storeAddress: 'CC Hipermall Las Cascadas, Local 121 y 122, Antiguo Cuscatlán',
    schedule: 'Lunes a Domingo: 9:00am a 7:00pm',
    phone: '22438385',
    whatsapp: '72752074',
    page: 'https://g.page/r/CVEdQ6pMeIOxEBM/',
    review: 'https://g.page/r/CVEdQ6pMeIOxEBM/review',
    zona: 1,
    LatLng: [{
      lat: 13.6781875,
      lng: -89.2517207
    }],
    type: 'par2'
  },
  {
    storecode: 'P59',
    placeName: 'PAR2 Santa Tecla',
    storeAddress: '2a. C. Ote. 2-4, Santa Tecla',
    schedule: 'Lunes a Sábado: 8:00am a 6:00pm<br>Domingo: 8:00am a 5:00pm',
    phone: '22281564',
    whatsapp: '72752074',
    page: 'https://g.page/r/CZiCRQvTmuPGEBM/',
    review: 'https://g.page/r/CZiCRQvTmuPGEBM/review',
    zona: 1,
    LatLng: [{
      lat: 13.6729696,
      lng: -89.286518
    }],
    type: 'par2'
  },
  {
    storecode: 'P61',
    placeName: 'PAR2 San Miguel Centro II',
    storeAddress: '2a. C. Pte. y 1a. Av. Nte. San Miguel',
    schedule: 'Lunes a Sábado: 8:00am a 6:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '26602672',
    whatsapp: '72752074',
    page: 'https://g.page/r/CbOVjCfFWLkdEBM/',
    review: 'https://g.page/r/CbOVjCfFWLkdEBM/review',
    zona: 4,
    LatLng: [{
      lat: 13.4823875,
      lng: -88.1776318
    }],
    type: 'par2'
  },
  {
    storecode: 'P62',
    placeName: 'PAR2 Chalchuapa',
    storeAddress: '5a. Av. Nte. No. 2, Gral. Ramón Flores, Chalchuapa',
    schedule: 'Lunes a Sábado: 08:00am a 5:00pm<br>Domingo: 08:00am a 04:00pm',
    phone: '24440735',
    whatsapp: '72752074',
    page: '',
    review: '',
    zona: 3,
    LatLng: [{
      lat: 13.9844475,
      lng: 89.6770121999999
    }],
    type: 'par2'
  },
  {
    storecode: 'P64',
    placeName: 'PAR2 Centro Santa Ana II',
    storeAddress: '1a. C. Pte. Edif. Zamora Santa Ana, Local 2',
    schedule: 'Lunes a Sábado: 8:00am a 6:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '24472154',
    whatsapp: '72752074',
    page: '',
    review: '',
    zona: 3,
    LatLng: [{
      lat: 13.9937281,
      lng: -89.5572585
    }],
    type: 'par2'
  },
  {
    storecode: 'P66',
    placeName: 'PAR2 Metapán',
    storeAddress: 'C. 15 de Septiembre Bo. San Pedro #1, Metapán',
    schedule: 'Lunes a Sábado: 8:00am a 5:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '24023023',
    whatsapp: '72752074',
    page: '',
    review: '',
    zona: 3,
    LatLng: [{
      lat: 14.3311401,
      lng: -89.4444612
    }],
    type: 'par2'
  },
  {
    storecode: 'P67',
    placeName: 'PAR2 Plaza Mundo Apopa',
    storeAddress: 'CC Plaza Mundo Apopa, Local 35 y 36, Km. 12 Ctra. Troncal del Nte. Apopa',
    schedule: 'Lunes a Domingo: 9:00am a 8:00pm',
    phone: '23062110',
    whatsapp: '72752074',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 13.7901981,
      lng: -89.1760108
    }],
    type: 'par2'
  },
  {
    storecode: 'P68',
    placeName: 'PAR2 Sensuntepeque',
    storeAddress: '2a. Av. Sur y 4a. C. Ote. No. 25, Sensuntepeque',
    schedule: 'Lunes a Sábado: 8:00am a 5:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '23820418',
    whatsapp: '72752074',
    page: 'https://goo.gl/maps/9bstuBf5fhBvg82i6',
    review: '',
    zona: 2,
    LatLng: [{
      lat: 13.8740959,
      lng: -88.6266681
    }],
    type: 'par2'
  },
  {
    storecode: 'P70',
    placeName: 'PAR2 Centro Santa Rosa de Lima',
    storeAddress: '1a. Av. Sur, y 2a. C. Pte. Bo. El Calvario, Santa Rosa de Lima',
    schedule: 'Lunes a Sábado: 8:00am a 5:00pm<br>Domingo: 8:00am a 4:00pm',
    phone: '26642743',
    whatsapp: '72752074',
    page: 'https://g.page/r/Cf_-oTO6NUGWEBM/',
    review: 'https://g.page/r/Cf_-oTO6NUGWEBM/review',
    zona: 4,
    LatLng: [{
      lat: 13.6257321,
      lng: -87.8921438
    }],
    type: 'par2'
  },
  {
    storecode: 'P71',
    placeName: 'PAR2 Centro San Salvador II',
    storeAddress: 'CC Dalumo, C. Rubén Darío #306 y 308, San Salvador',
    schedule: 'Lunes a Domingo: 8:00am a 6:00pm',
    phone: '22812998',
    whatsapp: '72752074',
    page: 'https://goo.gl/maps/qKYyg3Kpwaq9B9aR6',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 13.6986986,
      lng: -89.1937663
    }],
    type: 'par2'
  },
  {
    storecode: 'P73',
    placeName: 'PAR2 Metrocentro San Salvador',
    storeAddress: 'CC Metrocentro 8a. Etapa, Local 303-1, San Salvador',
    schedule: 'Domingo a Jueves: 9:00am a 7:00pm<br>Viernes y Sábado 9:00am a 8:00pm',
    phone: '22608824',
    whatsapp: '72752074',
    page: 'https://g.page/r/CUikBzaQAcEoEBM/',
    review: 'https://g.page/r/CUikBzaQAcEoEBM/review',
    zona: 1,
    LatLng: [{
      lat: 13.7056985,
      lng: -89.2105521
    }],
    type: 'par2'
  },
  {
    storecode: 'P76',
    placeName: 'PAR2 Metrocentro Sonsonate',
    storeAddress: 'CC Metrocentro Sonsonate, Local 13 y 14 D',
    schedule: 'Lunes a Domingo: 9:00am a 7:00pm',
    phone: '24514330',
    whatsapp: '72752074',
    page: 'https://g.page/r/CVGWn1fOqS3mEBM/',
    review: 'https://g.page/r/CVGWn1fOqS3mEBM/review',
    zona: 3,
    LatLng: [{
      lat: 13.7116962,
      lng: -89.7254456
    }],
    type: 'par2'
  },
  {
    storecode: 'P79',
    placeName: 'PAR2 Plaza Centro',
    storeAddress: 'CC Plaza Centro, Local 1 "i", Ex Edificio Simán Centro, San Salvador',
    schedule: 'Lunes a Domingo: 9:00am a 6:00pm',
    phone: '22215742',
    whatsapp: '72752074',
    page: 'https://g.page/r/CcoT_WGwR73dEBM/',
    review: 'https://g.page/r/CcoT_WGwR73dEBM/review',
    zona: 1,
    LatLng: [{
      lat: 13.6957245,
      lng: -89.1968109
    }],
    type: 'par2'
  },
  {
    storecode: 'P80',
    placeName: 'PAR2 Las Terrazas',
    storeAddress: 'CC. Las Terrazas, Local 335 y 336',
    schedule: 'Lunes a Sábado: 9:00am a 7:00pm<br>Domingo: 9:00am a 6:00pm',
    phone: '22351759',
    whatsapp: '72752074',
    page: 'https://goo.gl/maps/U5XwiJLQZqKgZWD39',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 13.711981905418456,
      lng: -89.18477048556873
    }],
    type: 'par2'
  },
  {
    storecode: 'P81',
    placeName: 'PAR2 CC Plaza Mundo Usulutan',
    storeAddress: 'CC Plaza Mundo Local 59 60 61 Km 119 Carr. Del Litoral CA-2, Ruta Nacional 14, Usulutan',
    schedule: 'Lunes a Domingo: 9:00am a 8:00pm',
    phone: '22351759',
    whatsapp: '72752074',
    page: 'https://goo.gl/maps/U5XwiJLQZqKgZWD39',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 13.343278,
      lng: -88.465943999999993
    }],
    type: 'par2'
  },

];  

var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("actived");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}

function addMarkerInfo(){
  for(var i=0; i < markersOnMap.length; i++){
    var contentString = '<div class="place-name">' + markersOnMap[i].placeName + '</div>';
    contentString += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
    contentString += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
    if(markersOnMap[i].phone !== "")
    	contentString += '<div class="place-link"><a class="place-link" href="tel:+503'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 4%"> (503)'+ markersOnMap[i].phone + '</a></div>';
    contentString += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 4%"> (503)' + markersOnMap[i].whatsapp + '</a></div>';
    contentString += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies El Salvador" style="width: 4%"> Navegar en Waze</a></div>';
    if(markersOnMap[i].page !== "")
    	contentString += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
    if(markersOnMap[i].review !== "")
    contentString += '<div class="place-link"><button name="add-comment" class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div>';

    const marker = new google.maps.Marker({
      position: markersOnMap[i].LatLng[0],
      icon: icons[markersOnMap[i].type].icon,
      map: map
    });

    const infowindow = new google.maps.InfoWindow({
      content: contentString
    });


    marker.addListener('click', function(){
      closeOtherInfo();
      infowindow.open(marker.get('map'),marker);
      InfoObj[0] = infowindow;
    });
    
    switch (markersOnMap[i].zona) {
      case 1: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+503'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 4%"> (503)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width: 4%">(503)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies El Salvador" style="width: 4%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button name="add-comment" class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info").innerHTML += contentDiv;
        		break;
      
      case 2: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+503'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width:  4%"> (503)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width:  4%">(503)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies El Salvador" style="width: 4%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button name="add-comment" class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info2").innerHTML += contentDiv;
        		break;
      
      case 3: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+503'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width:  4%"> (503)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width:  4%">(503)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies El Salvador" style="width: 4%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button name="add-comment" class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info3").innerHTML += contentDiv;
        		break;
      
      case 4: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+503'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width:  4%"> (503)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width:  4%">(503)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies El Salvador" style="width: 4%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button name="add-comment" class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info4").innerHTML += contentDiv;
        		break;
      
      default:
      			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+503'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width:  4%"> (503)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies El Salvador" style="width:  4%">(503)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies El Salvador" style="width: 4%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button name="add-comment" class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info").innerHTML += contentDiv;
        		break;
      
    }
  }
}

function closeOtherInfo(){
  if(InfoObj.length > 0){
    InfoObj[0].set("marker", null);
    InfoObj[0].close();
    InfoObj[0].length = 0;
  }
}

function SetCenterMap(posLat, posLon){
  var centerStore = {lat: posLat, lng: posLon};
  map.setCenter(centerStore);
}

function positionOk(pos){
  var latitudeMap = pos.coords.latitude;
  var longitudMap = pos.coords.longitude;
  var centerStore = {lat: latitudeMap, lng: longitudMap};
  map.setCenter(centerStore);
}

function positionKO(){
  const centerStore = {lat: 13.706105, lng: -89.2119793};
  map.setCenter(centerStore);
}

function initMap(){
  map = new google.maps.Map(document.getElementById('map'),{
    zoom: 16,
    center: {lat: 13.706105, lng: -89.2119793},
    mapId: '7b2b8c05c9abdb62'
  });

  if(navigator.geolocation){
    navigator.geolocation.getCurrentPosition(positionOk, positionKO);            
  }

  addMarkerInfo();
};

function openPage(pageName,elmnt) {
  var i, tabcontent;
  
  tabcontent = document.getElementsByClassName("tabcontent2");
  
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  };
    
  document.getElementById(pageName).style.display = "block";
  elmnt.style.borderBottom = "6px solid #FF6B00";
}